import type { TOC } from '@ember/component/template-only';
import { local } from 'embroider-css-modules';
import isDrawerExpanded from 'lumen/helpers/is-drawer-expanded';
import { DRAWER_IDS } from 'lumen/utils/constants/general-constants';

import styles from './main.module.css';

interface GeneralPageMainSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const GeneralPageMain: TOC<GeneralPageMainSignature> = <template>
  <div
    class={{local
      styles
      "main"
      (if
        (isDrawerExpanded DRAWER_IDS.SMART_INSIGHTS_DRAWER)
        "smart-insights-open"
      )
    }}
    id="main-content-wrapper-target"
    ...attributes
  >
    {{yield}}
  </div>
</template>;

export default GeneralPageMain;
